import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#uvod", label: "Úvod" },
  { href: "#o-nas", label: "O nás" },
  { href: "#sluzby", label: "Služby" },
  { href: "#galeria", label: "Galéria" },
  { href: "#kontakt", label: "Kontakt" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-black/70 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
          onClick={() => setOpen(false)}
        >
          <div className="w-9 h-9 border border-gold/50 flex items-center justify-center text-gold font-serif text-lg tracking-tight">
            T
          </div>
          <div className="leading-tight">
            <div className="font-serif text-lg text-cream tracking-tight">Tatra 603</div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-gold/80">
              Historický prenájom
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="text-[12px] uppercase tracking-[0.25em] text-cream/70 hover:text-gold transition-colors link-underline"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#kontakt"
            data-testid="nav-cta-inquiry"
            className="btn-gold"
          >
            Dopyt
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-cream"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-black/95 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-${l.href.replace("#", "")}`}
                className="text-sm uppercase tracking-[0.2em] text-cream/80"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#kontakt"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta"
              className="btn-gold w-fit"
            >
              Dopyt
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
